import React, {useEffect} from 'react';
import { BrowserRouter as Router, Route, Switch, Link, Redirect } from "react-router-dom";

import AppContext from './AppContext.js';
import PageLogin from './Components/PageLogin.jsx';
import PageForgotPassword from './Components/PageForgotPassword.jsx';
import CheckLogin from './Components/CheckLogin.js';
import Dashboard from './Components/Dashboard.jsx';
import { Error404 } from './Components/Errors.js';
import {getCookieByName} from "./Utils/Utils.js";
import PageURL from "./PageURL.js";

const App = function(props) {
  const [appState, setAppState] = React.useState({
    route : window.location.pathname + window.location.search
  });

  if (appState.user === undefined || appState.user === '') {
    return (
      <Router>
        <AppContext.Provider value={{ appState, setAppState }}>
          <div className="full-page">
            <Switch>
              <Route exact path={PageURL.forgotPassword}>
                <PageForgotPassword />
              </Route>
              <Route>
                <CheckLogin />
              </Route>
            </Switch>
          </div>
        </AppContext.Provider>
      </Router>
    );
  }
  
  return (
    <Router>
      <AppContext.Provider value={{ appState, setAppState }}>
        <div className="full-page">
          <Route>
            <Dashboard />
          </Route>
          <Route exact path="/login">
            <Redirect to="/" />
          </Route>
        </div>
      </AppContext.Provider>
    </Router>
  );
};

export default App;